<template>
  <i class="icon_wrap"></i>
</template>

<script>
export default {
  name: 'WeChatIcon'
};
</script>

<style scoped lang="stylus">
.icon_wrap {
  display inline-block
  width 24px
  height 24px
  background-size 24px 24px
  background-repeat no-repeat
  background-position center
  background-image url('./images/h5_payment_icon_WeChat@3x.png')
}
</style>
